import gql from 'graphql-tag';
import authFragment from './fragments/authFragment';

export default gql`
  ${authFragment}
  mutation createMemberToken($email: String!, $password: String!) {
    createToken(Email: $email, Password: $password) {
      ...authFragment
    }
  }
`;
